import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Redirect } from "react-router-dom";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";
import { withRouter, Link } from "react-router-dom";

import { loginFormValidationSchema, initialValues } from "./FormValidations";
import { TextInput, PasswordInput, Checkbox } from "../../components/Input";
import { CustomButton } from "../../components/CustomButton";
import { APP_ROUTES } from "../../helpers/routeHelpers";
import { login } from "../../store/actions";
import AuthWrapper from "./AuthWrapper";
import PageTitles from "../../constants/PageTitles";
import Headings from "./Headings";
import { ERROR, SUCCESS, showToast } from "../../utils/toastUtils";
import { LABLES, NAMES, PLACEHOLDERS } from "./AuthFieldsNames";
import { FormikErrorText } from "../../components/FormikErrorText";
import { UserRoleType } from "../../constants";

const Login = ({}) => {
    let { EMAIL, PASSWORD } = LABLES;
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    let isAuthenticated = useSelector((state) => state.userAuth.isAuthenticated);

    const formik = useFormik({
        initialValues: initialValues.loginForm,
        validationSchema: loginFormValidationSchema,
        onSubmit: (values) => {
            handleFormSubmit(values);
        }
    });

    // Load saved credentials on component mount
    useEffect(() => {
        const savedEmail = localStorage.getItem("rememberedEmail");

        const savedRememberMe = localStorage.getItem("rememberMe") === "true";

        if (savedEmail && savedRememberMe) {
            formik.setValues({
                ...formik.values,
                email: savedEmail
            });
            setRememberMe(savedRememberMe);
        }
    }, []);

    const handleFormSubmit = async (values) => {
        const { email, password } = values;
        try {
            setIsLoading(true);

            // Save credentials if Remember Me is checked
            if (rememberMe) {
                localStorage.setItem("rememberedEmail", email);
                localStorage.setItem("rememberMe", true);
            } else {
                localStorage.removeItem("rememberedEmail");
                localStorage.removeItem("rememberMe");
            }

            await dispatch(
                login({
                    email: email,
                    password: password,
                    rememberToken: true,
                    type: UserRoleType.ADMIN
                })
            );

            showToast(SUCCESS, "Login successfully!");
        } catch (err) {
        } finally {
            setIsLoading(false);
        }
    };

    if (isAuthenticated) {
        return <Redirect to={APP_ROUTES.DASHBOARD} />;
    }

    return (
        <>
            <Helmet>
                <title>{PageTitles.LOGIN}</title>
            </Helmet>
            <AuthWrapper>
                <div className="w-100  mt-4">
                    <div className="w-100 d-flex align-items-center justify-content-center">
                        <Headings title="Welcome to Allayya" subText="Sign in to continue." />
                    </div>

                    <form className="w-100 mt-4" onSubmit={formik.handleSubmit}>
                        <div className="mb-2">
                            <TextInput
                                placeholder={PLACEHOLDERS[EMAIL]}
                                label={EMAIL}
                                name={NAMES[EMAIL]}
                                type={NAMES[EMAIL]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values[NAMES[EMAIL]]}
                                className="hide-default-icon"
                                autoFocus
                            />
                            <FormikErrorText formikInstance={formik} fieldName={NAMES[EMAIL]} />
                        </div>

                        <div className="mb-2">
                            <PasswordInput
                                placeholder={PLACEHOLDERS[PASSWORD]}
                                label={PASSWORD}
                                name={NAMES[PASSWORD]}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values[NAMES[PASSWORD]]}
                            />
                            <FormikErrorText formikInstance={formik} fieldName={NAMES[PASSWORD]} />
                        </div>

                        <div className="d-flex align-items-center justify-content-between mb-2">
                            <div className="d-flex align-items-center">
                                {/* <Checkbox
                                    classes={"me-2"}
                                    withMargin={false}
                                    checked={rememberMe}
                                    onChange={(e) => setRememberMe(e.target.checked)}
                                />
                                <span className="auth-bottom-text">Remember me</span> */}
                            </div>
                            <Link to={APP_ROUTES.FORGET_PASSWORD}>
                                <p className="font-clr-theme-secondary auth-bottom-text">
                                    Forgot password?
                                </p>
                            </Link>
                        </div>

                        <CustomButton
                            loading={isLoading}
                            type="submit"
                            color="primary"
                            title="Sign In"
                            className="w-100 grad-primary mt-4 "
                        />
                    </form>
                </div>
            </AuthWrapper>
        </>
    );
};

export default withRouter(Login);
